define('home/templates/channelTopicTab',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<span class=\"button--tag -inverted button-large\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.topicName : depth0), depth0))
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"alert alert--topics\">\n<div class=\"align align--between\">\n<div class=\"align align--wrap align--middle\">\n<div class=\"spacing-right\">\n<strong>"
    + alias2(helpers.gettext.call(alias1,"Channel Topic",{"name":"gettext","hash":{},"data":data}))
    + ":</strong>\n</div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.topicName : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n\n<a href=\"/home/channel/"
    + alias2(container.lambda(((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.slug : stack1), depth0))
    + "/\" class=\"link-green-dark\" title=\""
    + alias2(helpers.gettext.call(alias1,"Remove Filter",{"name":"gettext","hash":{},"data":data}))
    + "\">\n<span class=\"icon-cancel icon-tiny\"></span>\n</a>\n</div>\n</div>\n<div data-role=\"header-area\"></div>\n<div data-role='content-area'></div>\n<div data-role='footer-area'></div>\n";
},"useData":true})

});
